import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              UAE’s Innovation Hub: Pioneering the Evolution of iOS App
              Development in Dubai
            </h2>
            <p>
              As one of the top iPhone app development agencies in Dubai,
              TekRevol's iOS app development services aim to enable your growth
              and adaptation in a fast-moving environment. Employing advanced
              technology, we create iPhone apps that provide a competitive
              advantage and enhance customer engagement
            </p>
            <p>
              Our skilled team works closely with you to understand your
              distinctive business requirements and goals.
            </p>
            <p>
              We modify our iOS app development procedures to offer scalable
              solutions that develop with your business growth. You can count on
              TekRevol as a leading iOS app development agency that crafts the
              digital tools vital for staying ahead in the UAE and GCC market.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <StaticImage
                src="../../images/location_new/fold11/ios-dubai.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={775}
                height={670}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
